import { gql } from "@apollo/client";

export const UpdateRentingEndDate = gql`
  mutation UpdateRentingEndDate($rentingId: String!, $newEndDate: Date!) {
    updateRentingEndDate(rentingId: $rentingId, newEndDate: $newEndDate) {
      _id
      machine
      machineInfo {
        name
      }
      status
      startedRent
      previsionEndingRent
    }
  }
`; 